module.exports = __webpack_public_path__ + "img/avatar.6df28699.svg";